import React, { useState } from "react";
import { MProgressBar } from "@/components/ui/atoms/MProgressBar";

const ProgressBarTest: React.FC = () => {
  const [progress, setProgress] = useState(50);

  return (
    <div style={{ padding: 32, maxWidth: 400 }}>
      <h2 style={{ fontWeight: 700, fontSize: 20, marginBottom: 24 }}>
        MProgressBar Demo
      </h2>
      <div style={{ marginBottom: 24 }}>
        <label>Progress: {progress}%</label>
        <input
          type="range"
          min={0}
          max={100}
          value={progress}
          onChange={(e) => setProgress(Number(e.target.value))}
          style={{ width: 200, marginLeft: 16 }}
        />
      </div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ marginBottom: 8 }}>Large</div>
        <MProgressBar progress={progress} size="large" />
      </div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ marginBottom: 8 }}>Medium</div>
        <MProgressBar progress={progress} size="medium" />
      </div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ marginBottom: 8 }}>Small</div>
        <MProgressBar progress={progress} size="small" />
      </div>
    </div>
  );
};

export default ProgressBarTest;
